import {Divider, Menu, MenuProps, Modal, Space} from 'antd'
import React, {useEffect, useState} from 'react'
import Input from '../../components/UI/Input'
import {
  AuditOutlined, DeleteOutlined, EditOutlined, EyeOutlined,
  FileTextOutlined,
  HomeOutlined,
  MinusOutlined,
  PlusOutlined,
  PrinterOutlined,
  TagsOutlined, ToolOutlined
} from "@ant-design/icons";
import Button from "../../components/UI/Button";
import List from "../../components/List";
import {compareNumbers, stringCompare} from "../../utils/sorters";
import {sendSystemLog} from "../../context/AuthProvider/useAuth";
import {getAllowCreateNewDevicePermission, getPermission} from "../../services/permisssion";
import permissionType from "../../utils/permissionType";
import {getDevicesList} from "../../services/devices";
import loading from "../../components/UI/Loading";
import {useLoading} from "../../context/LoadingProvider/useLoading";
import {addTag, addTagToDevices, deleteTag, getAllTags, getDeviceTags, removeTagFromDevices} from "../../services/tags";

interface modalTagsSelectorProps {
  visible: boolean
  deviceList: never[]
  title: string
  onClose: () => void
  isManufacturer: boolean
}


function ModalSelector(props: modalTagsSelectorProps) {
  const [search, setSearch] = useState('')
  const loading = useLoading()

  const getItems = () => {

    let ret : MenuProps['items'] = [];
    ret.push({
      label: 'Add',
      key: 'add',
      icon: <PlusOutlined />}
    );
    ret.push({
      label: 'Remove',
      key: 'remove',
      icon: <MinusOutlined/>
    });
    ret.push({
      label: 'Delete Permanently',
      key: 'delete',
      icon: <DeleteOutlined/>
    });
    return ret;

  }
  const [current, setCurrent] = useState('add');

  const [addValue, setAddValue] = useState('')
  const [add, setAdd] = useState(true)
  const [addTagOptions, setAddTagOptions] = useState([]
  )

  const [removeTagOptions, setRemoveTagOptions] = useState([]
  )

  // @ts-ignore
  const filteredAddOptions = addTagOptions.filter(option => option.name.toLowerCase().includes(search.toLowerCase()))
  // @ts-ignore
  const filteredRemoveOptions = removeTagOptions.filter(option => option.name.toLowerCase().includes(search.toLowerCase()))
  // @ts-ignore
  const filteredDeleteOptions = addTagOptions.filter(option => option.name.toLowerCase().includes(search.toLowerCase()) && option.useCount === 0)


  useEffect(() => {
    (async() =>{
      loading.addLoading()
      const res = await getAllTags()
      if (res) {
        setAddTagOptions(res.tags)
      }
      if (props.deviceList.length > 0) {
        const resDev = await getDeviceTags(props.deviceList)
        if (resDev)
          setRemoveTagOptions(resDev.tags)
      }
      loading.removeLoading()
    })()
  }, [props.deviceList])

  const onSelectRecord = (option: string) => {
    props.onClose()
  }


  const saveNewTag = async (option: string) => {
    const res = await addTag(option)
    if (res) {
      setAddTagOptions(res.tags)
    }
    setAddValue('')
  }

  const addTagToDevicesLocal = async (id: string) => {
    if (props.deviceList.length > 0) {
      const res = await addTagToDevices(id, props.deviceList)
      if (res)
        setRemoveTagOptions(res.tags)
      const res1 = await getAllTags()
      if (res1) {
        setAddTagOptions(res1.tags)
      }
    } else {
      console.log("Device list is empty")
    }
  }

  const removeTagFromDevicesLocal = async (id: string) => {
    if (props.deviceList.length > 0) {
      const res = await removeTagFromDevices(id, props.deviceList)
      if (res)
        setRemoveTagOptions(res.tags)
      const res1 = await getAllTags()
      if (res1) {
        setAddTagOptions(res1.tags)
      }
    } else {
      console.log("Device list is empty")
    }
  }

  const deleteTagLocal = async (id: string) => {
   const res = await deleteTag(id)
    if (res.tags.length > 0)
      setAddTagOptions(res.tags)
  }

  useEffect(() => {

  }, [addTagOptions])

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };
  const getTotalTagUseCount = (id: string) => {
    console.log('getTotalTagUseCount Tag ' + id)
    let retVal = false;
    console.log(JSON.stringify(removeTagOptions))
    removeTagOptions.forEach(function(tag, index)
    {
      // @ts-ignore
      console.log('Tag ' + tag.name + ' Count ' + tag.useCount)
      // @ts-ignore
      if (tag.id === id){
        // @ts-ignore
        retVal = tag.useCount === props.deviceList.length;
      }
    })
    return retVal
  }
  const getActionButtons = (id: string, name: string) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => addTagToDevicesLocal(id)}
              type='secondary'
              style={{backgroundColor: '#2fa4e7'}}
              disabled={getTotalTagUseCount(id)}
          >
            <PlusOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }

  const getRemoveActionButtons = (id: string, type: string) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => removeTagFromDevicesLocal(id)}
              type='secondary'
              style={{backgroundColor: '#2fa4e7'}}
          >
            <MinusOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }

  const getDeleteActionButtons = (id: string, type: string) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => deleteTagLocal(id)}
              type='secondary'
              style={{backgroundColor: 'red'}}
          >
            <DeleteOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }


  return (
    <>
        <Modal open={props.visible} title={props.title} onCancel={props.onClose} onOk={props.onClose}
               cancelButtonProps={{ style: { display: 'none' } }}
               okButtonProps={{ style: { display: 'none' } }}
        >
          <div className="modal-selector">
            <Menu style={{ backgroundColor: 'transparent' }} onClick={onClick} selectedKeys={[current]} mode="horizontal" items={getItems()} />


            {current === 'add' &&
            <>
            <div className="modal-selector__search" >
              <Space>
              <Input
                label="Add"
                value={addValue}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddValue(e.target.value)}
                placeholder="New Tag"
              />
              <Button
                  onClick={() =>  saveNewTag(addValue)}
                  type='primary'
              >
                <PlusOutlined style={{ fontSize: '16px', color: '#FFF' }} />
              </Button>
              </Space>
              <Input
                  label="Filter"
                  value={search}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                  placeholder="Type to search"
              />

            </div>
            <div className="modal-selector__options">
              <List

                  rows={filteredAddOptions}
                  columns={[
                    {
                      title: 'Actions',
                      dataIndex: 'id',
                      key: 'id',
                      render: (value: string, record: any) => getActionButtons(value, record.name),
                      width: 50
                    },

                    {
                      title: 'Tag',
                      dataIndex: 'name',
                      key: 'name',
                      render: (value: string, record: any) => record.distributorId!==null && props.isManufacturer?value + ' (D)': value,
                      sorter: (a: any, b: any) => stringCompare(a.name, b.name),
                    },
                  ]}
              />
            </div>
            * Disabled add button denotes all devices in this group has the tag already

            </>
        }
            {current === 'remove' &&
                <>
                  <div className="modal-selector__search" >
                    <Input
                        label="Filter"
                        value={search}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                        placeholder="Type to search"
                    />

                  </div>
                  <div className="modal-selector__options">
                    <List

                        rows={filteredRemoveOptions}
                        columns={[
                          {
                            title: 'Actions',
                            dataIndex: 'id',
                            key: 'id',
                            render: (value: string, record: any) => getRemoveActionButtons(value, record.type),
                            width: 50
                          },

                          {
                            title: 'Tag',
                            dataIndex: 'name',
                            key: 'name',
                            render: (value: string, record: any) => record.distributorId!==null && props.isManufacturer?value + ' (D)': value,
                            sorter: (a: any, b: any) => stringCompare(a.name, b.name),
                          },
                        ]}
                    />
                  </div>
                  * Only shows tags in use with this group of devices
                </>
            }
            {current === 'delete' &&
                <>
                  <h4>This will permanently remove the tag from the system.
                    If a tag you wish to delete is not in this list, it is attached to a device and must be removed first.</h4>
                  <div className="modal-selector__search" >
                    <Input
                        label="Filter"
                        value={search}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                        placeholder="Type to search"
                    />

                  </div>
                  <div className="modal-selector__options">
                    <List

                        rows={filteredDeleteOptions}
                        columns={[
                          {
                            title: 'Actions',
                            dataIndex: 'id',
                            key: 'id',
                            render: (value: string, record: any) => getDeleteActionButtons(value, record.type),
                            width: 50
                          },

                          {
                            title: 'Tag',
                            dataIndex: 'name',
                            key: 'name',
                            render: (value: string, record: any) => record.distributorId!==null && props.isManufacturer ?value + ' (D)': value,
                            sorter: (a: any, b: any) => stringCompare(a.name, b.name),
                          },
                        ]}
                    />
                  </div>
                </>
            }
            <>
              { props.isManufacturer &&
                <p>(D) - Distributor tag</p>
              }
            </>
          </div>
        </Modal>
    </>
  )
}

export default ModalSelector
